<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <!--      <a-form-model-item label="师傅id,外键{zb_user.id}" prop="userId" >
              <a-input v-model="form.userId" placeholder="请输入师傅id,外键{zb_user.id}" />
            </a-form-model-item>-->
      <a-form-model-item label="提现金额" prop="withdrawalMoney">
        <a-input v-model="form.withdrawalMoney" disabled placeholder="请输入提现金额"/>
      </a-form-model-item>
      <a-form-model-item label="手续费" prop="commission">
        <a-input v-model="form.commission" disabled placeholder="请输入手续费"/>
      </a-form-model-item>
      <a-form-model-item label="到账金额" prop="amountReceived">
        <a-input v-model="form.amountReceived" disabled placeholder="请输入到账金额"/>
      </a-form-model-item>
      <a-form-model-item label="提现类型">
        <a-input v-model="form.accountTypeName" disabled placeholder="暂无提现类型"/>
      </a-form-model-item>
      <a-form-model-item v-if="isWechatWithdrawal" label="打款二维码">
        <div v-if="form.paymentCode" class="payment-code-wrap">
          <img class="payment-code-image" :src="form.paymentCode" alt="打款二维码">
        </div>
        <span v-else>暂无打款二维码</span>
      </a-form-model-item>
      <template v-else-if="isBankCardWithdrawal">
        <a-form-model-item label="开户名称">
          <a-input v-model="form.realname" disabled placeholder="暂无开户名称"/>
        </a-form-model-item>
        <a-form-model-item label="银行卡号">
          <a-input v-model="form.bankCardNo" disabled placeholder="暂无银行卡号"/>
        </a-form-model-item>
        <a-form-model-item label="支行信息">
          <a-input v-model="form.bankBranch" disabled placeholder="暂无支行信息"/>
        </a-form-model-item>
      </template>
      <template v-else>
        <a-form-model-item label="真实姓名">
          <a-input v-model="form.realname" disabled placeholder="暂无真实姓名"/>
        </a-form-model-item>
        <a-form-model-item label="打款码">
          <a-input v-model="form.paymentCode" disabled placeholder="暂无打款码"/>
        </a-form-model-item>
      </template>
      <a-form-model-item label="审核原因" prop="reason">
        <a-textarea v-model="form.reason" :rows="4" placeholder="驳回时请输入审核原因，通过时可不填"/>
      </a-form-model-item>
      <!--      <a-form-model-item label="提现时间" prop="withdrawalTime" >
              <a-date-picker style="width: 100%" v-model="form.withdrawalTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
            </a-form-model-item>
            <a-form-model-item label="审核时间" prop="examineTime" >
              <a-date-picker style="width: 100%" v-model="form.examineTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
            </a-form-model-item>
            <a-form-model-item label="备注" prop="remark" >
              <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
            </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="handleApprove">
            通过
          </a-button>
          <a-button type="danger" :loading="submitLoading" @click="handleReject">
            驳回
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { approveWithdrawal, getWithdrawal, rejectWithdrawal } from '@/api/master/withdrawal'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,
        userId: null,
        withdrawalMoney: null,
        commission: null,
        amountReceived: null,
        accountTypeName: null,
        realname: null,
        paymentCode: null,
        bankCardNo: null,
        bankBranch: null,
        reason: null
      },
      open: false,
      rules: {
        withdrawalMoney: [
          { required: true, message: '提现金额不能为空', trigger: 'blur' }
        ],
        commission: [
          { required: true, message: '手续费不能为空', trigger: 'blur' }
        ],
        amountReceived: [
          { required: true, message: '到账金额不能为空', trigger: 'blur' }
        ],
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    isWechatWithdrawal () {
      return Number(this.form.accountType) === 0
    },
    isBankCardWithdrawal () {
      return Number(this.form.accountType) === 2
    }
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.form = {
        id: null,
        userId: null,
        withdrawalMoney: null,
        commission: null,
        amountReceived: null,
        accountTypeName: null,
        realname: null,
        paymentCode: null,
        bankCardNo: null,
        bankBranch: null,
        reason: null
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      const id = row ? row.id : ids
      getWithdrawal({ id: id }).then(response => {
        this.form = response.data
        this.form.reason = null
        this.open = true
        this.formTitle = '审核'
      })
    },
    handleApprove () {
      if (!this.form.id) {
        return
      }
      this.submitLoading = true
      approveWithdrawal({ id: this.form.id }).then(() => {
        this.$message.success('审核通过成功', 3)
        this.open = false
        this.$emit('ok')
      }).finally(() => {
        this.submitLoading = false
      })
    },
    handleReject () {
      this.$refs.form.validateField('reason', (errorMessage) => {
        if (errorMessage) {
          return
        }
        this.submitLoading = true
        rejectWithdrawal({
          id: this.form.id,
          reason: this.form.reason
        }).then(() => {
          this.$message.success('审核驳回成功', 3)
          this.open = false
          this.$emit('ok')
        }).finally(() => {
          this.submitLoading = false
        })
      })
    }
  }
}
</script>
<style scoped>
.payment-code-wrap {
  width: 160px;
  height: 160px;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  overflow: hidden;
}

.payment-code-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}
</style>
